import React, { useContext } from "react";
import { useMediaQuery } from "@material-ui/core";
import { breakpoints } from "../../../../constants/styled-components";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import LoadingOverlay from "@common/LoadingOverlay";

import ProductsOnSaleGrid from "./ProductsOnSaleGrid";
import { WebSettingsContext } from "@providers/WebsettingsProvider";
import {
  productsOnSaleSelector,
  fetchproductsOnSale,
  intitalizeLoader,
} from "@slices/Promotions/productsOnSale";
import { useGetLoggedInUserInfo } from "@hooks";

const ProductOnSale: React.FC<{ onAddToCartActon: Function }> = (props) => {
  const sessionId = useGetLoggedInUserInfo();

  const dispatch = useDispatch();
  const state = useSelector(productsOnSaleSelector);
  const loading = state.loading;

  const webSettingsData: any = useContext(WebSettingsContext);

  const isMobile = useMediaQuery(`(min-width:${breakpoints.sm})`);
  useEffect(() => {
    dispatch(intitalizeLoader());
    dispatch(fetchproductsOnSale(webSettingsData?.languageCode));
  }, [dispatch, sessionId?.sessionId]);

  return (
    <section className="section-content padding-y prod-on-sale-position">
      {state?.productsOnSale?.productList?.length > 0 ? (
        <div className="container">
          <div className="row">
            <ProductsOnSaleGrid
              products={state?.productsOnSale?.productList}
              loading={false}
              hasErrors={false}
              onAddToCartActon={props?.onAddToCartActon}
            />
          </div>
        </div>
      ) : (
        " "
      )}
      <LoadingOverlay active={loading} />
    </section>
  );
};

export default ProductOnSale;
